export const PRODUCT_LIST_REQUEST = "PRODUCT_LIST_REQUEST";
export const PRODUCT_LIST_SUCCESS = "PRODUCT_LIST_SUCCESS";
export const PRODUCT_LIST_FAIL = "PRODUCT_LIST_FAIL";

export const PRODUCT_DETAILS_REQUEST = "PRODUCT_DETAILS_REQUEST";
export const PRODUCT_DETAILS_SUCCESS = "PRODUCT_DETAILS_SUCCESS";
export const PRODUCT_DETAILS_FAIL = "PRODUCT_DETAILS_FAIL";

export const PRODUCT_DELETE_REQUEST = "PRODUCT_DELETE_REQUEST";
export const PRODUCT_DELETE_SUCCESS = "PRODUCT_DELETE_SUCCESS";
export const PRODUCT_DELETE_FAIL = "PRODUCT_DELETE_FAIL";

export const PRODUCT_CREATE_REQUEST = "PRODUCT_CREATE_REQUEST";
export const PRODUCT_CREATE_SUCCESS = "PRODUCT_CREATE_SUCCESS";
export const PRODUCT_CREATE_FAIL = "PRODUCT_CREATE_FAIL";
export const PRODUCT_CREATE_RESET = "PRODUCT_CREATE_RESET";

export const PRODUCT_BULK_UPLOAD_REQUEST = "PRODUCT_BULK_UPLOAD_REQUEST";
export const PRODUCT_BULK_UPLOAD_SUCCESS = "PRODUCT_BULK_UPLOAD_SUCCESS";
export const PRODUCT_BULK_UPLOAD_FAIL = "PRODUCT_BULK_UPLOAD_FAIL";
export const PRODUCT_BULK_UPLOAD_RESET = "PRODUCT_BULK_UPLOAD_RESET";

export const PRODUCT_UPDATE_REQUEST = "PRODUCT_UPDATE_REQUEST";
export const PRODUCT_UPDATE_SUCCESS = "PRODUCT_UPDATE_SUCCESS";
export const PRODUCT_UPDATE_FAIL = "PRODUCT_UPDATE_FAIL";
export const PRODUCT_UPDATE_RESET = "PRODUCT_UPDATE_RESET";

export const PRODUCT_CREATE_REVIEW_REQUEST = "PRODUCT_CREATE_REVIEW_REQUEST";
export const PRODUCT_CREATE_REVIEW_SUCCESS = "PRODUCT_CREATE_REVIEW_SUCCESS";
export const PRODUCT_CREATE_REVIEW_FAIL = "PRODUCT_CREATE_REVIEW_FAIL";
export const PRODUCT_CREATE_REVIEW_RESET = "PRODUCT_CREATE_REVIEW_RESET";

export const REVIEW_LIST_REQUEST = "REVIEW_LIST_REQUEST";
export const REVIEW_LIST_SUCCESS = "REVIEW_LIST_SUCCESS";
export const REVIEW_LIST_FAIL = "REVIEW_LIST_FAIL";

export const REVIEW_APPROVE_REQUEST = "REVIEW_APPROVE_REQUEST";
export const REVIEW_APPROVE_SUCCESS = "REVIEW_APPROVE_SUCCESS";
export const REVIEW_APPROVE_FAIL = "REVIEW_APPROVE_FAIL ";

export const REVIEW_DELETE_REQUEST = "REVIEW_DELETE_REQUEST";
export const REVIEW_DELETE_SUCCESS = "REVIEW_DELETE_SUCCESS";
export const REVIEW_DELETE_FAIL = "REVIEW_DELETE_FAIL";
export const REVIEW_DELETE_RESET = "REVIEW_DELETE_RESET";

export const PRODUCT_VARIANTS_REQUEST = "PRODUCT_VARIANTS_REQUEST";
export const PRODUCT_VARIANTS_SUCCESS = "PRODUCT_VARIANTS_SUCCESS";
export const PRODUCT_VARIANTS_FAIL = "PRODUCT_VARIANTS_FAIL";

export const PRODUCT_GROUP_DETAILS_REQUEST = "PRODUCT_GROUP_DETAILS_REQUEST";
export const PRODUCT_GROUP_DETAILS_SUCCESS = "PRODUCT_GROUP_DETAILS_SUCCESS";
export const PRODUCT_GROUP_DETAILS_FAIL = "PRODUCT_GROUP_DETAILS_FAIL";

export const PRODUCT_GROUP_UPDATE_REQUEST = "PRODUCT_GROUP_UPDATE_REQUEST";
export const PRODUCT_GROUP_UPDATE_SUCCESS = "PRODUCT_GROUP_UPDATE_SUCCESS";
export const PRODUCT_GROUP_UPDATE_FAIL = "PRODUCT_GROUP_UPDATE_FAIL";

export const PRODUCT_VARIANT_UPDATE_REQUEST = "PRODUCT_VARIANT_UPDATE_REQUEST";
export const PRODUCT_VARIANT_UPDATE_SUCCESS = "PRODUCT_VARIANT_UPDATE_SUCCESS";
export const PRODUCT_VARIANT_UPDATE_FAIL = "PRODUCT_VARIANT_UPDATE_FAIL";

export const PRODUCT_VARIANT_ADD_REQUEST = "PRODUCT_VARIANT_ADD_REQUEST";
export const PRODUCT_VARIANT_ADD_SUCCESS = "PRODUCT_VARIANT_ADD_SUCCESS";
export const PRODUCT_VARIANT_ADD_FAIL = "PRODUCT_VARIANT_ADD_FAIL";

export const PRODUCT_EDIT_REQUEST = "PRODUCT_EDIT_REQUEST";
export const PRODUCT_EDIT_SUCCESS = "PRODUCT_EDIT_SUCCESS";
export const PRODUCT_EDIT_FAIL = "PRODUCT_EDIT_FAIL";

export const PRODUCT_LIST_BY_GROUP_REQUEST = "PRODUCT_LIST_BY_GROUP_REQUEST";
export const PRODUCT_LIST_BY_GROUP_SUCCESS = "PRODUCT_LIST_BY_GROUP_SUCCESS";
export const PRODUCT_LIST_BY_GROUP_FAIL = "PRODUCT_LIST_BY_GROUP_FAIL";

export const VARIANT_ADD_REQUEST = "VARIANT_ADD_REQUEST";
export const VARIANT_ADD_SUCCESS = "VARIANT_ADD_SUCCESS";
export const VARIANT_ADD_FAIL = "VARIANT_ADD_FAIL";
export const VARIANT_ADD_RESET = "VARIANT_ADD_RESET";
// PRODUCT GROUP FETCH
export const PRODUCT_GROUP_REQUEST = "PRODUCT_GROUP_REQUEST";
export const PRODUCT_GROUP_SUCCESS = "PRODUCT_GROUP_SUCCESS";
export const PRODUCT_GROUP_FAIL = "PRODUCT_GROUP_FAIL";
//combo
export const PRODUCT_HAS_COMBO_REQUEST = "PRODUCT_HAS_COMBO_REQUEST";
export const PRODUCT_HAS_COMBO_SUCCESS = "PRODUCT_HAS_COMBO_SUCCESS";
export const PRODUCT_HAS_COMBO_FAIL = "PRODUCT_HAS_COMBO_FAIL";

export const REVIEW_UNAPPROVE_REQUEST = "REVIEW_UNAPPROVE_REQUEST";
export const REVIEW_UNAPPROVE_SUCCESS = "REVIEW_UNAPPROVE_SUCCESS";
export const REVIEW_UNAPPROVE_FAIL = "REVIEW_UNAPPROVE_FAIL";
